import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { isNull } from 'util';
import { FormGroup } from '@angular/forms';

export function generateParamsForRoutes(filters: any, page: number = null, pageSize: number = null) {
    const params: any = {};
    if (!isNull(page)) { params.page = page; }
    if (!isNull(pageSize)) { params.pageSize = pageSize; }
    if (filters) {
        // tslint:disable-next-line:forin
        for (const key in filters) {
            params[key] = filters[key];
        }
    }
    return params;
}

export function isEmpty(field) {
    let valid = true;
    // Objectd
    if (typeof field === 'object') {
        for (const key in field) {
            if (field.hasOwnProperty(key)) {
                valid = false;
            }
        }
    } else if (field !== '') {
        valid = false;
    }

    // Array
    if (Array.isArray(field)) {
        if (field.length > 0) {
            valid = false;
        }
    }

    return valid;
}

export function toModelDate(date: NgbDateStruct): Date {
    return date ? new Date(date.year + '-' + date.month + '-' + date.day) : null;
}

export function isNullOrEmptyOrUndefined(field) {
    let valid = false;
    if (field === '' || field === null || field === undefined) {
        valid = true;
    }
    return valid;
}


export function generateOption(arr: any) {
    const options: any = [];
    // tslint:disable-next-line:forin
    for (const key in arr) {
        const opt = { key: '', name: '' };
        opt.key = key;
        opt.name = arr[key];
        options.push(opt);
    }
    return options;
}

export function addOrderToFilters(filters, columnSettings) {
    const column = columnSettings.find(item => item.isActive === true);
    if (!isNullOrEmptyOrUndefined(column) && !isNullOrEmptyOrUndefined(filters)) {
        // tslint:disable-next-line:no-string-literal
        filters['order'] = (column.sortAsc) ? column.sortKey + ',ASC' : column.sortKey + ',DESC';
    }
    return filters;
}

export function patchValueByItemArray(formGroup: FormGroup, items: any[], key: string, control: string) {
    const arr = [];
    items.forEach( item => {
        arr.push(item[key]);
    });
    formGroup.get(control).setValue(arr);
}

export function objectKeysToArray(obj: object) {
    const temp = [];
    Object.keys(obj).forEach( item => {
        temp.push(item);
    });
    return temp;
}
